var render = function render(){var _vm=this,_c=_vm._self._c;return _c('registration',{attrs:{"login-route":"login","is-dark":true,"is-loading":_vm.isLoading,"solo":true,"outlined":false,"icon-enabled":true,"email-required-enabled":false},on:{"register":_vm.onRegister}})
}
var staticRenderFns = []

export { render, staticRenderFns }